import { render, staticRenderFns } from "./MonitorItemTable.vue?vue&type=template&id=a974aa10"
import script from "./MonitorItemTable.vue?vue&type=script&lang=js"
export * from "./MonitorItemTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports